// import { useState } from 'react';
// import StepEnterEmail from './StepEnterEmail';
// import StepEnterOtp from './StepEnterOtp';
// import StepResetPassword from './StepResetPassword';
// import { Box, Container, Grid } from '@mui/material';
// import { ToastContainer } from 'react-toastify';
// import { styled } from '@mui/material/styles';

// const StyledContent = styled('div')(({ theme }) => ({
//   maxWidth: 480,
//   margin: 'auto',
//   minHeight: '100vh',
//   display: 'flex',
//   justifyContent: 'center',
//   flexDirection: 'column',
//   padding: theme.spacing(12, 0)
// }));

// export default function ForgotPassword() {
//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   console.log('first');
//   return (
//     <main className="min-h-screen bg-gradient-secondary">
//       <div className="min-h-screen flex">
//         {/* Logo Section */}
//         <div
//           className="hidden lg:flex lg:w-1/2 items-center justify-center p-12
//     bg-gradient-to-br from-[#E8BF21] to-[#000000]
//                  relative overflow-hidden"
//         >
//           <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px]"></div>
//           <div className="relative z-10 text-center max-w-md">
//             <div className="mb-8 flex justify-center">
//               <img
//                 src="/logo.png"
//                 alt="Av Work Force"
//                 className="w-full max-w-sm h-auto object-contain filter brightness-0 invert"
//               />
//             </div>

//             <p className="text-white/90 text-lg leading-relaxed">
//               Excellence in workforce management and professional staffing
//               solutions
//             </p>
//           </div>
//         </div>

//         {/* Login Form Section */}
//         <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
//           <div className="w-full max-w-md">
//             {/* Mobile Logo */}
//             <div className="lg:hidden text-center mb-8">
//               <img
//                 src="/logo.png"
//                 alt="Av Work Force"
//                 className="w-64 h-auto mx-auto object-contain mb-4"
//               />
//               <h1 className="text-2xl font-bold text-foreground mb-2">
//                 Av Work Force
//               </h1>
//             </div>
//             <>
//               {step === 1 && (
//                 <StepEnterEmail
//                   onNext={(e) => {
//                     setEmail(e);
//                     setStep(2);
//                   }}
//                 />
//               )}
//               {step === 2 && (
//                 <StepEnterOtp
//                   email={email}
//                   onNext={(o) => {
//                     setOtp(o);
//                     setStep(3);
//                   }}
//                 />
//               )}
//               {step === 3 && <StepResetPassword email={email} otp={otp} />}
//             </>
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// }

import { useState } from 'react';
import StepEnterEmail from './StepEnterEmail';
import StepEnterOtp from './StepEnterOtp';
import StepResetPassword from './StepResetPassword';
import { AdminRecoveryAuthMode } from '../../auth/adminRealmRecovery';

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [authMode, setAuthMode] =
    useState<AdminRecoveryAuthMode | null>(null);

  return (
    <main className="min-h-screen bg-gradient-to-b from-[#000000] to-[#E8BF21]">
      <div className="min-h-screen flex">
        {/* Logo Section */}
        <div className="hidden lg:flex lg:w-1/2 items-center justify-center p-12 relative overflow-hidden">
          <div className="relative z-10 text-center max-w-md">
            <div className="mb-8 flex justify-center">
              <img
                src="/logo.png"
                alt="Av Work Force"
                className="w-full max-w-sm h-auto object-contain filter brightness-0 invert"
              />
            </div>

            <p className="text-white/90 text-lg leading-relaxed">
              Excellence in workforce management and professional staffing
              solutions
            </p>
          </div>
        </div>

        {/* Forgot Password Form Section */}
        <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
          <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-8">
            {/* Mobile Logo */}
            <div className="lg:hidden text-center mb-8">
              <img
                src="/logo.png"
                alt="Av Work Force"
                className="w-64 h-auto mx-auto object-contain mb-4"
              />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                Av Work Force
              </h1>
            </div>

            {/* Step Components */}
            <>
              {step === 1 && (
                <StepEnterEmail
                  onNext={(e, recoveryAuthMode) => {
                    setEmail(e);
                    setAuthMode(recoveryAuthMode);
                    setStep(2);
                  }}
                />
              )}
              {step === 2 && (
                <StepEnterOtp
                  email={email}
                  authMode={authMode}
                  onNext={(o) => {
                    setOtp(o);
                    setStep(3);
                  }}
                />
              )}
              {step === 3 && (
                <StepResetPassword
                  email={email}
                  otp={otp}
                  authMode={authMode}
                />
              )}
            </>
          </div>
        </div>
      </div>
    </main>
  );
}
